<style>
  input:disabled,
  select:disabled {
    cursor: no-drop;
  }

  input:disabled {
    color: #a8a8a8;
  }
</style>

<div
  class="arrange-pickup-dialog-header"
>
  <h1 style="font-size: 24px; margin-bottom: 0">
    Arrange Pick Up
    <span style="color: #ff6c36">#{{shipment.shipment_number}}</span>
  </h1>
  <button (click)="closeWithoutAddItem()">
    <i class="fas fa-times" style="font-size: 24px; color: red"></i>
  </button>
</div>

<div mat-dialog-content>
  <form ngNativeValidate [formGroup]="form">
    <div class="container">
      <div class="arrange-pickup-main-wrapper">
        <div class="col-date">
          <div style="margin-bottom: 0px; margin-top: 14px" class="form-group">
            <p
              style="
                color: black;
                font-size: 14px;
                font-weight: 500;
                margin-bottom: 10px;
              "
            >
              Pick up date
            </p>

            <mat-form-field>
              <input
                matInput
                [matDatepicker]="picker"
                [matDatepickerFilter]="weekendFilter"
                [min]="minDate"
                (dateChange)="dateSelected($event)"
                [max]="maxDate"
                formControlName="pickUpDate"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="col-times">
          <div style="margin-top: 14px">
            <p
              style="
                color: black;
                font-size: 14px;
                font-weight: 500;
                margin-bottom: 10px;
              "
            >
              Between hours
            </p>

            <div class="b2b-arrange-pickup-time-picker-wrapper">
              <div class="b2b-arrange-pickup-time-picker-from-time">
                <label for="" style="min-width: 50px">From</label>
                <mat-form-field>
                  <input
                    matInput
                    name="selected_time_A"
                    [format]="24"
                    [min]="minStartTime"
                    [max]="maxStartTime"
                    [ngxMatTimepicker]="pickerA"
                    placeholder="09:00"
                    readonly
                    formControlName="startTime"
                  />
                  <mat-icon matSuffix (click)="pickerA.open()">
                    watch_later
                  </mat-icon>
                  <ngx-mat-timepicker
                    timepickerClass="shippn-time-picker-arange-pickup"
                    #pickerA
                    [hoursOnly]="true"
                    matSuffix
                    (timeSet)="selectFromTime($event)"
                  ></ngx-mat-timepicker>
                </mat-form-field>
              </div>

              <div class="b2b-arrange-pickup-time-picker-to-time">
                  <label for="">To</label>
                  <mat-form-field>
                    <input
                      matInput
                      name="selected_time_B"
                      [format]="24"
                      [max]="maxEndTime"
                      [min]="minEndTime"
                      [ngxMatTimepicker]="pickerB"
                      placeholder="12:00"
                      readonly
                      [disabled]="isEndTimeSelectable"
                      formControlName="endTime"
                    />
                    <mat-icon matSuffix (click)="pickerB.open()">
                      watch_later
                    </mat-icon>
                    <ngx-mat-timepicker
                      timepickerClass="shippn-time-picker-arange-pickup"
                      #pickerB
                      [hoursOnly]="true"
                      matSuffix
                      (timeSet)="selectEndTime($event)"
                    ></ngx-mat-timepicker>
                  </mat-form-field>
              </div>
            </div>

            <div class="warning-box">
              <p>
                *The available pick up time period you specify must be at least
                3 hours.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions style="justify-content: flex-end">
  <button
    mat-flat-button
    color="primary"
    class="shippn-mat-btn"
    (click)="saveArrangePickUp()"
    cdkFocusInitial
  >
    SAVE
  </button>
</div>
